export default {
  meta: {
    title: '加盟商线索' // 加盟商线索
  }
};
